import { Pipe, PipeTransform } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable, filter, map } from 'rxjs';
import { AppStateInterface } from 'src/app/stores/global/appState.interface';
import { employeesSelector, getEmployees } from 'src/app/stores/global/employees/employees.store';

@Pipe({
    name: 'employee',
    standalone: false
})
export class EmployeePipe implements PipeTransform {
  constructor(private store: Store<AppStateInterface>
  ) {
    this.store.dispatch(getEmployees());
  }

  transform(employeeId: string): Observable<string> {
    return this.store.pipe(select(employeesSelector)).pipe(
      filter((employees) => employees.length > 0),
      map((employees) =>
        employees.find((employee) => employee.id === employeeId)
      ),
      map((employee) => `${employee?.firstName} ${employee?.lastName}`)
    );
  }

}
